import { types } from 'mobx-state-tree'
import moment from 'moment/moment'
import 'moment-timezone'
import object_value from '../api/object_value'
import _ from 'underscore'
import { simple_api_request } from '../api/simple_api_request'

// TODO: Add support
const Query = types.model({
  city_id: types.maybe(types.number),
  category_id: types.maybe(types.number),
  start_date_moment: types.maybe(types.string),
  start_date: types.maybe(types.string),
  end_date_moment: types.maybe(types.string),
  end_date: types.maybe(types.string)
  // month: types.maybe(types.number),
  // number_guests: types.maybe(types.number)
})

const ExperiencesSearchStore = types.model({
  status: types.maybe(types.string),
  status_message: types.maybe(types.string),
  query: types.optional(types.frozen, {}),
  experiences: types.optional(types.frozen, [])
}).actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    set (key, value) {
      console.log('ExperiencesSearchStore - set:', ...arguments)
      const current_query = self.query

      self.query = {
        ...current_query,
        [key]: value
      }
    },
    clean_query () {
      self.query = {}
    },
    clean () {
      self.clean_query
      self.status = null
      self.status_message = null
      self.experiences = null
    },
    request() {
      self.status = 'loading'

      const query = self.filtered_query
      delete query.start_date_moment
      delete query.end_date_moment
      console.log('ExperiencesSearchStore - request() - query:', query)

      const request_parameters = query
        ? {
            path: '/api/experiences/search',
            data: query,
            method: 'POST'
          }
        // : {
        //     path: '/api/experiences',
        //     method: 'GET'
        //   }
        : {
            path: '/api/experiences/search',
            method: 'POST'
          }

      simple_api_request(request_parameters).then(
        self.process_response
      )
    },
    process_response (result) {
      console.log('ExperiencesSearchStore - process_response() - result:', result)

      if (result.ok) {
        self.status = 'success'
        self.experiences = result.data
      } else {
        let message = object_value(result, 'data.message')
        let errors = object_value(result, 'data.errors', {})
        if (errors !== null && typeof errors === 'object') {
          for (let [key, value] of Object.entries(errors)) {
            if (value.length > 0) {
              let fetch_text = ''

              value.forEach(t => {
                fetch_text = fetch_text + t + '<br>'
              })

              message = message + `<br><strong>${key}</strong>:<br>${fetch_text}`
            }
          }
        }

        self.status = 'error'
        self.status_message = message
      }
    }
  })
).views(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get filtered_query () {
      const query = self.query

      if (!query) {
        return false
      }

      let filtered_query = {}

      for (let [key, value] of Object.entries(query)) {
       if (!!value) {
         filtered_query[key] = value
       }
      }

      if (Object.keys(filtered_query).length < 1) {
        return false
      }

      return filtered_query
    },
    get sorted_experiences () {
      let experiences = self.experiences

      if (!experiences || experiences.length < 1) {
        return []
      }

      let format_date = (date) => {
        return moment(date).utc()/*.tz('Europe/Berlin')*/.isSame(moment(), 'day')
          ? moment(date).utc()/*.tz('Europe/Berlin')*/.format('[Today - ]HH:mm')
          : moment(date).utc()/*.tz('Europe/Berlin')*/.format('DD.MM.YYYY - HH:mm')
      }

      // As native `.sort()` has some bug, use underscore
      experiences = _.sortBy(experiences, 'computed_date_getTime')

      // Group
      let updated_experiences = []
      for (let experience of experiences) {
        let date = object_value(experience, 'events.0.date')
        if (date) {
          let computed_date = new Date(date)
          experience.formatted_date = format_date(computed_date)
          experience.computed_date = computed_date
          experience.computed_date_getTime = computed_date.getTime()
          updated_experiences.push(experience)
        }
      }

      console.log('ExperiencesSearchStore - updated_experiences:', updated_experiences)
      return updated_experiences
    }
  })
)

export default ExperiencesSearchStore



// WEBPACK FOOTER //
// ./src/stores/ExperiencesSearchStore.js